module.exports = __webpack_public_path__ + "static/about-solutions-0f6e50a76fb8cf8838669a632d80ff15.png";